import { reactive, getCurrentInstance } from "vue";
import { useFilters } from "@/composables/filters/useFilters";
import { deleteResponsibilityBadge } from "@/api";
let instance = null;

export function useViewState() {
  if (instance) return instance;
  const filter = useFilters();
  const app = getCurrentInstance();
  const { proxy } = app || {};
  const state = reactive({
    filters: {
      values: [],
      searchText: "",
      showFilterDialog: false,
      key: "readinessEmployees",
      clearSelection: "",
      needsRecalculation: false,
    },
    loading: {
      table: false,
    },
    table: {
      currentPage: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      search: "",
    },
    showRemoveBadgeDialog: false,
    selectedBadge: null,
    getCoachResponsibilties: false,
    isForceBadge: false,
    currentResponsibilityName: "",
  });

  const applyFilters = (filters) => {
    const newArray = filters
      .map((item) => {
        if (item.value !== null) {
          if (typeof item === "string") {
            return item;
          } else if (
            typeof item === "object" &&
            // eslint-disable-next-line no-prototype-builtins
            item.hasOwnProperty("value")
          ) {
            return item.value;
          }
        }
      })
      .filter(Boolean);
    filter.setFilters({ key: state.filters.key, filters: newArray });
    state.filters.values = newArray;
    state.filters.showFilterDialog = false;
  };

  const removeFilters = (removedFilters) => {
    filter.setFilters({
      key: state.filters.key,
      filters: state.filters.values,
    });
    state.filters.clearSelection = removedFilters;
  };
  const getEmployeeCardProps = (data) => {
    return {
      firstName: data?.employee?.first_name,
      lastName: data?.employee?.last_name,
      position: data?.employee?.title,
      photoUrl: data?.employee?.avatar,
      availability: data?.employee?.availability,
      showAvailability: true,
      showLinkUnderline: false,
      hideAvailabilitySelector:
        data?.employee?.primary_positions?.length > 0 || false,
      isAllocated: data?.employee?.primary_positions?.length > 0 || false,
      isHoverEnabled: false,
    };
  };
  const getProficiencyBadgeProps = (obj) => {
    return {
      level: getBadgeLevel(obj?.badge?.level),
      dot: obj?.badge?.status,
      view: formatProficiencyBadge(obj?.badge?.remove_method),
      expiration_date: obj?.badge?.expiration_date,
      has_expiration_if_obsolete: obj.badge?.expires_when_obsolete,
    };
  };
  const getInspectionIssueBadgeProps = (obj) => {
    return {
      currentBadgeLevel: obj.currentBadgeLevel,
      currentBadgeStatus: obj.currentBadgeStatus,
      checkpoints: obj.checkpoints,
      useCountsVariant: true,
      checkpointCounts: obj.checkpointCounts || {},
      // showInspectionButtons: true,
    };
  };
  const getBadgeLevel = (level) => {
    const levels = ["Novice", "Apprentice", "Professional", "Coach", "Master"];
    if (levels.includes(level)) {
      return level;
    } else {
      return levels[level];
    }
  };

  const formatProficiencyBadge = (badge) => {
    if (badge === "forced") {
      return "Removed";
    }
    if (!badge) {
      return "Editable";
    }
    return badge.charAt(0).toUpperCase() + badge.slice(1);
  };

  const getOrgObjectCardProps = (obj) => {
    return {
      code: obj.code,
      name: obj.name,
      showIcon: false,
      removeUnderlineToName: true,
      dynamicWidth: true,
      maxWidth: "450px",
    };
  };
  const getSwitcherProps = (obj) => {
    return {
      label: "",
      value: obj.isCoach,
    };
  };
  const handleOptionClick = (item) => {
    console.log("🚀 ~ handleOptionClick ~ item:", item);
    state.currentResponsibilityName = item.name;
    const hasActiveStatus = item.checkpoints.some(
      (item) => item.status == "active"
    );
    console.log("🚀 ~ handleOptionClick ~ hasActiveStatus:", hasActiveStatus);
    // viewState.state.isForceBadge = true;
    if (hasActiveStatus) {
      state.isForceBadge = false;
    } else {
      state.isForceBadge = true;
    }
  };

  // Métodos para filtros
  const updateFilter = (filterName, value) => {
    if (filterName in state.filters) {
      state.filters[filterName] = value;
    }
  };

  const clearFilters = () => {
    state.filters = {
      status: "all",
      department: null,
      position: null,
    };
  };

  // Métodos para loading
  const setLoading = (key, value) => {
    if (key in state.loading) {
      state.loading[key] = value;
    }
  };
  const removeProficiencyBadge = (item) => {
    state.showRemoveBadgeDialog = true;
    state.selectedBadge = item;
  };
  const handleRemoveBadge = async () => {
    console.log(state.selectedBadge, "selectedBadge");
    proxy.$loader.setAppLoading(true);
    try {
      const payload = {
        badge: state.selectedBadge?.badge?.id,
        method: "string",
        reason: state.selectedBadge.reason
          ? state.selectedBadge.reason
          : "string",
      };
      const accountID = localStorage.getItem("currentAccountID");
      await deleteResponsibilityBadge(
        accountID,
        state.selectedBadge?.badge?.id,
        payload
      );
      state.getCoachResponsibilties = true;
      state.showRemoveBadgeDialog = false;
    } catch (e) {
      console.error("Error removing badge: ", e);
    } finally {
      proxy.$loader.setAppLoading(false);
    }
  };

  instance = {
    state,
    updateFilter,
    clearFilters,
    setLoading,
    getOrgObjectCardProps,
    getSwitcherProps,
    applyFilters,
    removeFilters,
    getEmployeeCardProps,
    getProficiencyBadgeProps,
    getInspectionIssueBadgeProps,
    removeProficiencyBadge,
    handleRemoveBadge,
    handleOptionClick,
  };
  return instance;
}
